import React from "react";
import ReactDOM from "react-dom";
import ExportCsvButton from "./ExportCsvButton"; 
import "./StackTraceResolverModal.css";

const StackTraceResolverModal = ({
                                     isOpen,
                                     onClose,
                                     resolving,
                                     error,
                                     results,
                                 }) => {
    if (!isOpen) return null;

    const truncate = (text, max = 350) =>
        !text ? "" : text.length > max ? text.slice(0, max) + "..." : text;

    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>Kapat</button>
                <h3 style={{marginTop: 0, marginBottom: 10}}>Stack Trace Çözüm Sonuçları</h3>

                {resolving && (
                    <div style={{textAlign: "center", color: "#666", margin: "30px 0 10px 0"}}>
                        Çözümleme yapılıyor, lütfen bekleyin...
                    </div>
                )}
                {error && (
                    <div style={{color: "#d32f2f", fontWeight: 600, margin: "12px 0 8px 0"}}>
                        {error}
                    </div>
                )}
                {!resolving && !error && results && results.length > 0 && (
                    <>
                        <div style={{display: "flex", justifyContent: "flex-end", marginBottom: 12}}>
                            <ExportCsvButton
                                logs={results}
                                headers={["ID", "Date", "Version", "Error", "ResolvedStack", "Message"]}
                                keys={["Id", "LogDate", "Version", "Error", "ResolvedStack", "Message"]}
                                fileName="stacktrace_resolved.csv"
                            />
                        </div>
                        <div className="table-container">
                            <table className="fixed-table">
                                <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Tarih</th>
                                    <th>Version</th>
                                    <th>Hata</th>
                                    <th>Stack Trace</th>
                                    <th>Mesaj</th>
                                </tr>
                                </thead>
                                <tbody>
                                {results.map((r) => (
                                    <tr key={r.Id}>
                                        <td data-label="ID">{r.Id}</td>
                                        <td data-label="Tarih">{r.LogDate}</td>
                                        <td data-label="Version">{r.Version}</td>
                                        <td data-label="Hata"
                                            style={{color: r.Error ? "#d32f2f" : "#7c7c7c"}}>{r.Error}</td>
                                        <td data-label="Stack Trace">
                                            <pre className="stack-preview">{r.ResolvedStack}</pre>
                                        </td>
                                        <td data-label="Mesaj">
        <pre className="stack-preview" style={{background: "#f9f9ff"}}>
          {truncate(r.Message)}
        </pre>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </>
                )}
                {!resolving && !error && (!results || results.length === 0) && (
                    <div style={{textAlign: "center", color: "#888", margin: "30px 0 10px 0"}}>
                        Çözüm sonucu görüntülenecek kayıt yok.
                    </div>
                )}
            </div>
        </div>,
        document.body
    );
};

export default StackTraceResolverModal;
